import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { IconArrowRight1, IconSearchNormal } from '@/features/icons';
import { getCdnUrl } from '@/utils/url';
import { useSearchModal } from '../../search';
interface Props {
  hideBackButton?: boolean;
}
const SearchboxHeader = ({
  hideBackButton = false
}: Props) => {
  const router = useRouter();
  const {
    open: openSearchModal
  } = useSearchModal();
  const goBack = () => {
    router.back();
  };
  return <div className='flex w-full items-center gap-2' data-sentry-component="SearchboxHeader" data-sentry-source-file="searchbox-header.tsx">
            {!hideBackButton && <button type='button' onClick={goBack} className='shrink-0 cursor-pointer' aria-label='بستن'>
                    <IconArrowRight1 className='h-6 w-6 text-text-black' />
                </button>}

            <div role='button' className='flex h-10 flex-1 items-center gap-1 rounded bg-gray-100 px-1 py-2' onClick={openSearchModal}>
                <IconSearchNormal className='h-5 w-5 text-text-darkGray' data-sentry-element="IconSearchNormal" data-sentry-source-file="searchbox-header.tsx" />
                <span className='text-caption-12 text-text-mediumGray'>جست‌وجو در</span>
                <Image src={getCdnUrl('/_toad/images/brand/logo.svg?v=1.1')} alt='Khanoumi Logo' width={40} height={15} priority unoptimized className='w-10' data-sentry-element="Image" data-sentry-source-file="searchbox-header.tsx" />
            </div>
        </div>;
};
export default SearchboxHeader;